import DropzoneController from "./dropzone_controller";

export default class extends DropzoneController {
  static targets = ["dropzone", "preview", "attachmentFields", ...DropzoneController.targets];

  // Task form preview template - exact copy of support template
  get previewTemplate() {
    return `
      <div class="dz-preview dz-file-preview g-col-2 g-col-lg-1 position-relative border rounded m-0" style="overflow: hidden;">
        <!-- Image preview that fills the whole square -->
        <img data-dz-thumbnail class="w-100 h-100 rounded d-none" style="object-fit: cover;"/>

        <!-- File icon layout for non-images -->
        <div class="dz-file-content d-flex flex-column justify-content-center align-items-center w-100 h-100 p-2 text-center">
          <i class="dz-file-icon fa-3x text-muted mb-2"></i>
          <div class="text-truncate small fw-semibold w-100" data-dz-name style="max-width: 100px;"></div>
          <div class="text-muted small mt-1" data-dz-size></div>
        </div>

        <!-- Hover overlay for images -->
        <div class="attachment-hover-overlay position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-75 text-white px-2 py-1">
          <div class="text-truncate small fw-semibold">
            <span data-dz-name-overlay></span>
          </div>
          <small>(<span data-dz-size-overlay></span>)</small>
        </div>

        <div class="position-absolute top-0 end-0 p-1">
          <a href="#" class="dz-remove text-white bg-danger rounded-circle d-flex align-items-center justify-content-center" data-dz-remove title="Remove file" style="width: 20px; height: 20px; font-size: 12px;">
            <i class="fa fa-times"></i>
          </a>
        </div>
        <div class="dz-success-mark text-success position-absolute top-50 start-50 translate-middle d-none">
          <i class="fa fa-check-circle fa-2x"></i>
        </div>
        <div class="dz-progress position-absolute bottom-0 start-0 w-100" style="height: 4px; border-radius: 0 0 0.375rem 0.375rem;">
          <div class="dz-upload bg-primary" data-dz-uploadprogress style="height: 100%; width: 0%; transition: width 0.3s; border-radius: 0 0 0.375rem 0.375rem;"></div>
        </div>
        <div class="dz-error-message text-danger small position-absolute bottom-0 start-0 w-100 p-1 d-none" style="background-color: rgba(255,255,255,0.9); border-radius: 0 0 0.375rem 0.375rem;">
          <span data-dz-errormessage class="text-center d-block"></span>
        </div>
      </div>
    `;
  }

  connect() {
    super.connect();
  }

  // Override fileUploaded to add form field management
  fileUploaded(file, response) {
    super.fileUploaded(file, response);
    
    if (response.success) {
      // Add hidden field for form submission
      this.addAttachmentIdField(response.id);
    }
  }

  // Override fileRemoved to clean up form fields
  fileRemoved(file) {
    super.fileRemoved(file);

    if (file.attachmentId) {
      // Remove the hidden field
      const hiddenField = this.attachmentFieldsTarget.querySelector(`[data-attachment-id="${file.attachmentId}"]`);
      if (hiddenField) {
        hiddenField.remove();
      }
    }
  }

  addAttachmentIdField(attachmentId) {
    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = "task[attachment_ids][]";
    hiddenField.value = attachmentId;
    hiddenField.dataset.attachmentId = attachmentId;
    
    this.attachmentFieldsTarget.appendChild(hiddenField);
  }

  triggerFileSelect() {
    // Trigger the file input click
    if (this.hasFileSelectTarget) {
      this.fileSelectTarget.click();
    } else {
      // Fallback: find and click the file input
      const fileInput = this.element.querySelector('input[type="file"]');
      if (fileInput) fileInput.click();
    }
  }
}
